<template>
  <section> 
    <div class="container">
      <template v-for="(type, option) in this.option_list">
        <div class="row align-items-center">
          <div class="col-5">
            <label>{{ $t('lang.column.' + option) }}</label>
          </div>
           <div class="col-7" v-if="type=='text'">
            <span class="w-25 text-right">&nbsp;</span><input class="w-75" type="text" v-model="default_values['extended'][option]">
          </div>
          <div class="col-7" v-if="type=='number'">
            <span class="w-25 text-right">Min:&nbsp;</span><input class="w-75" type="number" min="0" v-model="default_values['extended'][option + '_min']">
            <span class="w-25 text-right">Max:&nbsp;</span><input class="w-75" type="number" min="0" v-model="default_values['extended'][option + '_max']">
          </div>
          <div class="col-7" v-if="type=='date'">
            <span class="w-25 text-right">From:&nbsp;</span><input class="w-75" type="date" v-model="default_values['extended'][option + '_min']">
            <span class="w-25 text-right">To:&nbsp;</span><input class="w-75" type="date" v-model="default_values['extended'][option + '_max']">
          </div>
        </div>
        <div class="dropdown-divider"></div>
      </template>
    </div>
  </section>
</template>
<script>

import { mapState, mapActions } from "vuex";

export default {
  props: {
    default_values: Object
  },
  created() {
    this.option_list = {
      'last_email_client':'text',
      'creation_date':'date',
      'last_update':'date',
      'first_email_date':'date',
      'last_email_date':'date',
      'total_emails_sent':'number',
      'total_manual_answers':'number',
      'total_calendar_clics':'number',
      'last_calendar_clic_date':'date',
      'last_meeting_booked':'date',
      'total_meetings_booked':'number'
    };
    this.default_values['extended'] = [];
    this.default_values['extended']['last_email_client'] = undefined
    this.default_values['extended']['creation_date_min'] = undefined
    this.default_values['extended']['creation_date_max'] = undefined
    this.default_values['extended']['last_update_min'] = undefined
    this.default_values['extended']['last_update_max'] = undefined
    this.default_values['extended']['first_email_date_min'] = undefined
    this.default_values['extended']['first_email_date_max'] = undefined
    this.default_values['extended']['last_email_date_min'] = undefined
    this.default_values['extended']['last_email_date_max'] = undefined
    this.default_values['extended']['total_emails_sent_min'] = undefined
    this.default_values['extended']['total_emails_sent_max'] = undefined
    this.default_values['extended']['total_manual_answers_min'] = undefined
    this.default_values['extended']['total_manual_answers_max'] = undefined
    this.default_values['extended']['total_calendar_clics_min'] = undefined
    this.default_values['extended']['total_calendar_clics_max'] = undefined
    this.default_values['extended']['last_calendar_clic_date_min'] = undefined
    this.default_values['extended']['last_calendar_clic_date_max'] = undefined
    this.default_values['extended']['last_meeting_booked_min'] = undefined
    this.default_values['extended']['last_meeting_booked_max'] = undefined
    this.default_values['extended']['total_meetings_booked_min'] = undefined
    this.default_values['extended']['total_meetings_booked_max'] = undefined
  }
}
</script>